import React from 'react'

const FilterGroup = ({ title, options, selected, onToggle, type }) => {
  return (
    <div className="filter-group">
      <h3 className="filter-group__title">{title}</h3>
      <div className="filter-group__options">
        {options.map((val) => (
          <div
            key={val}
            className={`filter-option filter-option--${type} ${
              selected.includes(val) ? 'active' : ''
            }`}
            onClick={() => onToggle(val)}
          >
            {type === 'power' && val === '10' ? '10+' : val}
          </div>
        ))}
      </div>
    </div>
  )
}

export default FilterGroup
